export default __webpack_public_path__ + "static/media/logo.a6f3c184.png";